import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FilterObject } from '../../shared/models/FilterObject';
import { InfoCenterFile } from '../../shared/models/InfoCenterFile';
import { PagingResults } from '../../shared/models/PagingResult';
import { FilterListObject } from '../../shared/models/FilterListObject';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { faXmark, faX, faArrowDown, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { Category } from '../../shared/models/Category';
import { CdkDrag, CdkDragDrop } from '@angular/cdk/drag-drop';


export interface IHeaders {
  type: string;
  file: {
    FullPath: string;
    FileName: string;
    CreateDate: Date;
    UpdateDate: Date;
    Active: boolean;
    FileData: File;
    FileType: string;
    Description: string;
    EnabledFor: string;
    Category: number;
    Type: string;
    Index: number;
  },
  category: {
    CategoryID: number;
    Name: string;
    CategoryType: string;
    SortOrder: number;
    ParentID: number;
    Files: InfoCenterFile[];
  }
}

@Component({
  selector: 'app-info-center',
  templateUrl: './info-center.component.html',
  styleUrls: ['./info-center.component.css']
})
export class InfoCenterComponent implements OnInit {
  @HostListener('CategoryTreeEditEvent', ['$event'])
  onCatEditEvent(event: any) {
    this.EditCategory(event.detail);
  }

  @HostListener('CategoryTreeDeleteEvent', ['$event'])
  onCatDeleteEvent(event: any) {
    this.DeleteCategory(event.detail);
  }

  @HostListener('FileEditEvent', ['$event'])
  onFileEditEvent(event: any) {
    this.EditFile(event.detail);
  }

  @HostListener('FileDeleteEvent', ['$event'])
  onFileDeleteEvent(event: any) {
    this.RemoveFile(event.detail);
  }

  readonly Page: string = "InfoCenter";
  FileList: InfoCenterFile[];
  Categories: Category[];
  RootCategories: Category[];
  CurUser: User;
  FilterList: FilterObject[];
  FileNameFilter: FilterObject;
  DocTypeList: FilterListObject[];
  FileTypeList: FilterListObject[];
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  readonly PageSizeOptions: number[] = [5, 10, 20, 50];

  PageIndex: number;
  PageSize: number;
  ItemCount: number;
  faXmark = faXmark;
  faX = faX;
  faArrowDown = faArrowDown;
  faPenToSquare = faPenToSquare;
  constructor(private global: GlobalService, private router: Router, private http: HttpService, public matDialog: MatDialog) { }

  ngOnInit(): void {
    this.CurUser = new User();
    this.DocTypeList = [];
    this.FileTypeList = [];
    this.FilterList = [];
    this.FileNameFilter = new FilterObject();
    this.PageIndex = 0;
    this.PageSize = 20;
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;

      if (this.CurUser && this.CurUser != null) {
        this.http.PostUserActivity(this.CurUser.UserId.toString(), "Info Center", "Load", "");
        this.GetCategories().then(x => {

          this.BuildFilterLists();
          this.LoadFiles();
        });
      }
      else {
        this.router.navigate(['/']);
      }
    });    
  }

  async GetCategories(){
    await this.http.GetCategories("infocenter").then(wrapper => {
      this.Categories = wrapper.Content;
      var tempDocTypeList = new Array<FilterListObject>();
      this.DocTypeList.forEach(doc => {
        tempDocTypeList.push(doc);
      });
      this.DocTypeList = [];
      this.Categories.forEach(cat => {
        this.DocTypeList.push(new FilterListObject().Build(cat.CategoryID.toString(), cat.Name, false));
      });

      this.RootCategories = this.Categories.filter(x => x.ParentID == null);

      tempDocTypeList.forEach(doc => {
        if (doc.Selected && this.DocTypeList.filter(x => x.Desc == doc.Desc && x.Value == doc.Value).length > 0) {
          this.DocTypeList.filter(x => x.Desc == doc.Desc && x.Value == doc.Value)[0].Selected = doc.Selected;
        }
      });
    });
  }


  GetCategoryName(id: number) {
    var cat = this.Categories.filter(x => x.CategoryID == id)[0];
    return cat.Name;
  }

  BuildFilterLists() {
    debugger;
   
    //this.DocTypeList.push(new FilterListObject().Build("webinar", "Webinars", false));
    //this.DocTypeList.push(new FilterListObject().Build("brochure", "Brochures", false));
    //this.DocTypeList.push(new FilterListObject().Build("cad", "CAD Files", false));

    this.FileTypeList.push(new FilterListObject().Build("xlsx", "XLS", false));
    this.FileTypeList.push(new FilterListObject().Build("mp4", "MP4", false));
    this.FileTypeList.push(new FilterListObject().Build("pdf", "PDF", false));
    this.FileTypeList.push(new FilterListObject().Build("ppt", "PPT", false));
    this.FileTypeList.push(new FilterListObject().Build("jpg", "JPG", false));
    this.FileTypeList.push(new FilterListObject().Build("bmp", "BMP", false));
    this.FileTypeList.push(new FilterListObject().Build("png", "PNG", false));
    this.FileTypeList.push(new FilterListObject().Build("gif", "GIF", false));
    
    this.FileNameFilter.Key = "filename";
    this.FileNameFilter.Value = "";
    this.FilterList.push(this.FileNameFilter);
  }


  LoadFiles() {

    for (var i = this.FilterList.length - 1; i >= 0; i--) {
      if (this.FilterList[i].Key == "doctype" || this.FilterList[i].Key == "filetype") {
        this.FilterList.splice(i, 1);
      }
    }

    this.DocTypeList.forEach(x => {
      if (x.Selected) {
        var newFilter = new FilterObject();
        newFilter.Key = "doctype";
        newFilter.Value = x.Value;
        newFilter.Operand = "equals";
        this.FilterList.push(newFilter);
      }
    });

    this.FileTypeList.forEach(x => {
      if (x.Selected) {
        var newFilter = new FilterObject();
        newFilter.Key = "filetype";
        newFilter.Value = x.Value;
        newFilter.Operand = "equals";
        this.FilterList.push(newFilter);
      }
    });

    this.http.GetAllInfoCenterFiles(this.FilterList,this.CurUser.UserId.toString()).then(wrapper => {
      if (wrapper.StatusCode == "200") {
        this.FileList = wrapper.Content;
        this.Categories.forEach(x => {
          this.FillCategory(x);
        });
      } else {
        var message = wrapper.Message;
      }
    });

  }

  FillCategory(cat: Category) {
    cat.Files = this.FileList.filter(x => x.Category == cat.CategoryID);
    if (cat.Children != null) {
      cat.Children.forEach(x => {
        this.FillCategory(x);
      });
    }
  }

  PreviewFile(file: InfoCenterFile) {
    this.http.DownloadInfoCenterFile(this.CurUser.UserId.toString(), file.InfoCenterFileID).pipe(
      map(({ body, headers }: HttpResponse<Blob>) => {
        debugger;
        const blob = new Blob([body], { type: headers.get('content-type') });
        var fileURL = URL.createObjectURL(blob);
        //window.open(fileURL, '_blank');
        var a = document.createElement("a");
        a.href = fileURL;
        a.target = "_blank";
        a.download = file.FileName;
        a.click();
      }
      ));

  }

  DownloadFile(file: InfoCenterFile) {
    this.http.PostUserActivity(this.CurUser.UserId.toString(), "Info Center", "Download File", file.FileName);
    if (file.Type == 'upload') {
      this.http.DownloadInfoCenterFile(this.CurUser.UserId.toString(), file.InfoCenterFileID).subscribe(({ body, headers }: HttpResponse<any>) => {
        debugger;
        var contentType = headers.get('content-type');
        const blob = new Blob([body], { type: contentType });
        var fileURL = URL.createObjectURL(blob);

        var a = document.createElement("a");
        a.href = fileURL;
        a.download = file.FileName;
        a.click();
      });
    }
    else {
      var a = document.createElement("a");
      a.href = file.FullPath;
      a.download = file.FileName;
      a.target = "_blank";
      a.click();
    }
  }

  PageEvent(event: any) {
    this.PageIndex = event.pageIndex;
    this.PageSize = event.pageSize;
    this.LoadFiles();
  }

  chkDocType_Change(docType: FilterListObject) {
    docType.Selected = !docType.Selected;
    this.LoadFiles();
  }

  chkFileType_Change(fileType: FilterListObject) {
    fileType.Selected = !fileType.Selected;
    this.LoadFiles();
  }

  FileNameFilter_Blur() {
    this.LoadFiles();
  }

  GetCatVisibility(cat: FilterListObject):boolean {
    var checked = this.DocTypeList.filter(x => x.Selected);

    if (checked.length == 0) {
      return false;
    }
    else {
      if (checked.filter(x => x.Value == cat.Value).length == 1) {
        return false;
      }
      else {
        return true;
      }
    }
  }

  GetDialogConfig(name: string): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = name;
    dialogConfig.height = "60%";
    dialogConfig.width = "85%";

    return dialogConfig;
  }

  AddNewFile(): void {
    var dialogConfig = this.GetDialogConfig("NewFile");
    dialogConfig.height = "60%";
    dialogConfig.width = "40%";

    var infoFileObj = {
      type: "addinfocenterfile",
      object: new InfoCenterFile(),
      cats:this.Categories
    }

    dialogConfig.data = infoFileObj;
    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);
    //this.CurrentOpenDialog.componentInstance.AddNewFileComp.SetNewFile(new InfoCenterFile());

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CloseModal();
    });
    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
      this.UploadFile(event);
      this.CloseModal();
    });
  }


  EditFile(file: InfoCenterFile) {
    var dialogConfig = this.GetDialogConfig("NewFile");
    dialogConfig.height = "60%";
    dialogConfig.width = "40%";

    var infoFileObj = {
      type: "editinfocenterfile",
      object: file,
      cats: this.Categories
    }

    dialogConfig.data = infoFileObj;
    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);
    //this.CurrentOpenDialog.componentInstance.AddNewFileComp.SetNewFile(new InfoCenterFile());

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CloseModal();
    });
    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
      this.UploadFile(event);
      this.CloseModal();
    });
  }

  UpdateFile(file: InfoCenterFile) {

  }

  UploadFile(newFile: InfoCenterFile) {
    if (newFile != null) {
      //do upload
      debugger;
      this.http.UploadInfoCenterFile(newFile, this.CurUser.UserId.toString()).then(x => {
        this.LoadFiles();
      });
    }
  }

  AddCategory(): void {
    var dialogConfig = this.GetDialogConfig("NewCategory");
    dialogConfig.height = "35%";
    dialogConfig.width = "40%";
    var newCat = new Category();
    newCat.CategoryType = "infocenter";
    var newFileObj = {
      type: 'category',
      object: newCat,
      cats:this.Categories
    };

    dialogConfig.data = newFileObj;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CloseModal();
    });

    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
      this.http.SaveCategory(event).then(x => {
        this.GetCategories().then(y => {
          this.CloseModal();
        });
        
      });
    });

  }


  EditCategory(catToEdit: Category) {
    if (catToEdit != undefined) {
      //var catToEdit = this.Categories.filter(x => x.CategoryID.toString() == edit)[0];

      var dialogConfig = this.GetDialogConfig("NewCategory");
      dialogConfig.height = "35%";
      dialogConfig.width = "40%";
      var newFileObj = {
        type: 'category',
        object: catToEdit,
        cats: this.Categories.filter(x => { return x.CategoryID !== catToEdit.CategoryID })
      };
      dialogConfig.data = newFileObj;
      this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

      this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
        this.CloseModal();
      });

      this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
        this.http.SaveCategory(event).then(x => {
          this.GetCategories().then(y => {
            this.CloseModal();
          });
        });
      });
    }
  }



  SaveCategory(toSave: Category) {
    this.http.SaveCategory(toSave).then(x => {

    });
  }

  CloseModal() {
    this.CurrentOpenDialog.close();
    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.removeAllListeners();
    this.CurrentOpenDialog = null;
  }

  RemoveFile(file: InfoCenterFile) {
    this.http.DeleteInfoCenterFile(file.InfoCenterFileID).then(x => {
      this.LoadFiles();
    });
  }

  DeleteCategory(del: number) {
    this.http.DeleteCategory(del).then(x => {
      if (x.StatusCode == "200") {
        this.GetCategories().then(y => {
          
        });
      }
      else if (x.StatusCode == "300") {
        this.ShowMessages(x.Message);
      }
    });
  }

  ShowMessages(messages:string) {
    var dialogConfig = this.GetDialogConfig("CPQMessages");

    var rmaObject = { type: "Messages", object: [messages] };
    dialogConfig.data = rmaObject;
    dialogConfig.height = "30%";
    dialogConfig.width = "30%";

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
      this.CurrentOpenDialog.close();
    });

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CurrentOpenDialog.close();
    });
  }

  FileDropped(event: CdkDragDrop<IHeaders[]>) {

    var catID = parseInt(event.item.data.data.CategoryID);
    if (event.currentIndex == event.previousIndex)
      return;

    var isMoveAhead = (event.currentIndex - event.previousIndex) < 0;
    var currentFile = this.RootCategories.filter(x => x.CategoryID == catID)[0];
    var catFileList = this.RootCategories;


    if (isMoveAhead) {
      for (var i = 0; i < catFileList.length; i++) {
        if (catFileList[i].SortOrder < event.previousIndex && catFileList[i].SortOrder >= event.currentIndex) {
          catFileList[i].SortOrder += 1;
        }
      }
    } else {
      for (var i = 0; i < catFileList.length; i++) {
        if (catFileList[i].SortOrder <= event.currentIndex && catFileList[i].SortOrder > event.previousIndex) {
          catFileList[i].SortOrder -= 1;
        }
      }
    }

    currentFile.SortOrder = event.currentIndex;

    catFileList.sort((a: any, b: any) => {
      if (a.SortOrder < b.SortOrder) {
        return -1;
      } else if (a.SortOrder > b.SortOrder) {
        return 1;
      } else {
        return 0;
      }
    });


    catFileList.forEach(x => {
      this.http.UpdateCategorySortOrder(x);
    });

  }

}
